/**
 * @fileoverview GET handler for the "/alloys/:partner/attribution/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnerAttributionAppGroupId } from "./constants";
import type { GetAlloysPartnerAttributionAppGroupIdResult } from "./types";
import { isGetAlloysPartnerAttributionAppGroupIdResult } from "./validators";

export const getAlloysPartnerAttributionAppGroupId = reactQueryFetcherAdapter(
  alloysPartnerAttributionAppGroupId,
  (
    signal: AbortSignal,
    partner: string,
    appGroupId: string
  ): Promise<GetAlloysPartnerAttributionAppGroupIdResult> => {
    return fetch(`/alloys/${partner}/attribution/${appGroupId}`, "GET", {}, { signal });
  },
  isGetAlloysPartnerAttributionAppGroupIdResult
);
